import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';
import { SuccessCard } from 'mobily-ui-library';
import { useGlobalStore } from '../stores/globalStore';
import './SuccessScreen.scss';

export const SuccessScreen = () => {
    const { t } = useTranslation();

    const { requestRefNumber = '', graphqlResponse, lang, formState } = useGlobalStore(useShallow((state) => ({
        requestRefNumber: state.requestRefNumber,
        graphqlResponse: state.graphqlResponse,
        lang: state.lang,
        formState: state.formState,
    })));


     let productTitle = "";
    if (lang === 'ar' && graphqlResponse?.data?.getProductOfferByID?.[0]?.offerLabels?.length > 0) {
        productTitle = graphqlResponse?.data?.getProductOfferByID?.[0]?.offerLabels[0]?.name;
    } else {
        productTitle = graphqlResponse?.data?.getProductOfferByID?.[0]?.name;
    }
    return (
        <div className='successCardWrapper'>
            <SuccessCard
                headerText={t("successScreen_successfully_requested")}
                descriptionText={""}
                detailsText={t("request_Number")}
                detailsNumber={requestRefNumber}
                detailsLinkUrl="#"
                nextStepsHeader={t("what_Happens_Next")}
                nextStepsDescription={t("sales_Agent_Call_You_Shortly")}
                email={formState?.emailAddress}
                emailLabel={t("successScreen_emailLabel")}
                orderLabel={t("successScreen_orderLabel")}
                orderName={productTitle}
            />
        </div>
    )
}